// removed by extract-text-webpack-plugin
module.exports = {"app":"app__1jWOq","app-body":"app-body__ZDg_6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/styles/main.scss
// module id = 2167
// module chunks = 1